import React, { use, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation } from "react-router-dom";
import Pricing from "./Components/Pricing";
import PricingComparision from "./Components/PricingComparision";

// IMAGES IMPORT LINK
// import ConsultationFlow from "./../components/ConsultationFlow";

export default function DetailedService({ AllServicesListing }) {
  const location = useLocation(); // ✅ Detect route change
  const [activeService, setActiveService] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    const ActiveService = AllServicesListing.filter(
      (item) => item.url === location.pathname.replaceAll("/services", "")
    );
    // console.log("Active Service --> ", ActiveService);
    setActiveService(ActiveService); // stays an array ✅
  }, [location.pathname, AllServicesListing]);

  return (
    <>
      {/* page-title */}
      <div className="prt-page-title-row style3">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-8 col-md-10 col-sm-9 ms-auto"></div>
            </div>
          </div>
        </div>
      </div>
      {/* page-title end */}

      {/* site-main start */}
      <div className="site-main">
        {/* aboutservice-section1 end */}
        {activeService && activeService.length > 0
          ? activeService.map((Service, idx) => {
              return (
                <section>
                  <div className="prt-row padding_zero-section aboutservice-section clearfix">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="prt-bg bg-base-grey aboutservice-block mt-20">
                            <div className="row">
                              <div className="col-lg-11 col-md-12 m-auto">
                                <div className="aboutservice-content container">
                                  <h3 className="title">
                                    Bharat Dhara – {Service.name}
                                  </h3>
                                  <p
                                    className="desc"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        Service.detailedPageTopDescription,
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="aboutservice-content container">
                    <h3 className="title">{Service.name}</h3>
                    <p className="desc">
                      Ayurveda believes every person is unique…
                    </p>
                  </div>

                  {Service.steps && Service.steps.length > 0
                    ? Service.steps.map((item, index) => {
                        return (
                          <div
                            key={`steps${index}`}
                            className="prt-row padding_bottom_zero-section about-section02 animation clearfix"
                          >
                            <div className="container">
                              <div className="row align-items-center">
                                {/* FULL-WIDTH TITLE ROW */}
                                <div className="row">
                                  <div className="col-12">
                                    <div className="section-title text-center">
                                      <div className="title-header">
                                        <h2 className="title">{item.title}</h2>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-md-12">
                                  <div>
                                    {/* section title */}
                                    <div className="section-title">
                                      <div className="title-desc">
                                        <section className="bd-summary">
                                          <h3 className="title">
                                            {item.subtitle}
                                          </h3>
                                          <div className="bd-cards">
                                            <article className="bd-card collect">
                                              <h4>{item.collectHead}</h4>
                                              <ul>
                                                {item.collect &&
                                                item.collect.length > 0
                                                  ? item.collect.map(
                                                      (subItem, index) => {
                                                        return (
                                                          <li
                                                            key={`collect${index}`}
                                                          >
                                                            <b>
                                                              {subItem.label}:
                                                            </b>{" "}
                                                            {subItem.value}
                                                          </li>
                                                        );
                                                      }
                                                    )
                                                  : null}
                                              </ul>
                                            </article>

                                            <article className="bd-card matters">
                                              <h4>{item.matters.heading}</h4>
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    item.matters.description,
                                                }}
                                              ></div>
                                            </article>
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-md-12">
                                  {/* prt_single_image-wrapper */}
                                  <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                                    <img
                                      width="635"
                                      height="500"
                                      className="img-fluid border-rad_10"
                                      src={item.image}
                                      alt="image"
                                    />
                                  </div>
                                  {/* prt_single_image-wrapper end */}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </section>
              );
            })
          : null}

        {/* Render the Consultation Flow here */}
        {/* <ConsultationFlow /> */}

        {/* <section
          className="prt-row padding_zero-section aboutservice-section clearfix"
          style={{ marginTop: "60px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">
                          Step 1: Registration & Intake (Pravesh)
                        </h3>
                        <p className="desc">
                          <section className="bd-summary-heading">
                            <h3>Summary</h3>
                            <p>
                              At Bharat Dhara, your consultation starts with
                              <b className="highlight">
                                {" "}
                                three simple but vital steps
                              </b>{" "}
                              — collecting personal details, recording lifestyle
                              habits, and noting medical history. Together,
                              these form the{" "}
                              <b className="highlight">
                                {" "}
                                foundation of your health record
                              </b>
                              , ensuring every Ayurvedic diagnosis and treatment
                              is
                              <b className="highlight">
                                {" "}
                                personalized, precise, and effective
                              </b>
                              .
                            </p>
                          </section>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <Pricing />

        <PricingComparision />

        {/* info-section */}
        <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-md-12">
                <div className="prt-info-main-block">
                  <div className="info_btn mr-30 res-767-mb-15">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      href="#"
                    >
                      COVID-19 resources
                    </a>
                  </div>
                  <div className="featured-icon-box icon-align-before-content style2">
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className="flaticon-alert"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>Get The Health package</h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          What you need to know about the 2019 - 2023 fly
                          season.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* info-section end */}
      </div>
      {/* site-main end */}
    </>
  );
}
